import { useThemePalette } from '../../hooks/useThemePalette';

/**
 * Chat-blocks color palette — reads V3 premium theme via useThemePalette when
 * available, otherwise falls back to the V3 default brand colors used across
 * the rest of the dashboard widgets (DonutWidget, LineChartWidget).
 *
 * Returns an array of hex colors (>=6 entries) safe to spread into Apex
 * `colors` option arrays.
 */
const DEFAULT_PALETTE = ['#06B6D4', '#3B82F6', '#8B5CF6', '#10B981', '#F59E0B', '#EF4444'];

export function useApexTheme() {
    const palette = useThemePalette();
    return palette || DEFAULT_PALETTE;
}

export const V3_COLORS = {
    teal:   '#06B6D4',
    blue:   '#3B82F6',
    purple: '#8B5CF6',
    green:  '#10B981',
    amber:  '#F59E0B',
    red:    '#EF4444',
};
